import React from 'react';
import { Modal } from 'react-bootstrap';
import FormGenerator from '../../../../../form-generator/FormGenerator';
import useLocalization from '../../../../../hooks/useLocalization';
import HorizontalProgress from '../../../../common/HorizontalProgress';
import { addStrategyForm, updateStrategyForm } from './form';

const AddUpdateStrategyModal = ({
  show,
  onHide,
  showProgress,
  size = 'lg',
  existingStrategy,
  toBeClonedStrategy,
  isSandboxed
}) => {
  const { translate } = useLocalization();

  return (
    <Modal size={size} show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton={!showProgress}>
        <Modal.Title className="flex-grow-1">
          <h6 className="mb-0">
            <b>
              {translate(
                toBeClonedStrategy ? `clone_strategy` : existingStrategy ? 'update_strategy_name' : 'new_strategy',
                { strategy: toBeClonedStrategy?.name }
              )}
            </b>
          </h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto py-4">
        {show && (
          <FormGenerator
            prefix="strategy"
            formJson={
              existingStrategy || toBeClonedStrategy
                ? updateStrategyForm(toBeClonedStrategy, translate)
                : addStrategyForm(translate)
            }
            formValues={{
              [existingStrategy || toBeClonedStrategy ? 'Update Strategy' : 'New Strategy']: {
                name: existingStrategy?.name || toBeClonedStrategy?.name || '',
                totalYears: existingStrategy?.totalYears || toBeClonedStrategy?.totalYears || 10,
                isDefaultSetupMode:
                  existingStrategy?.isDefaultSetupMode || toBeClonedStrategy?.isDefaultSetupMode
                    ? 'Add Mode'
                    : 'Buy Mode'
              }
            }}
          />
        )}
        {showProgress && (
          <HorizontalProgress
            text={`${translate(!existingStrategy ? 'adding_strategy' : 'updating_strategy_name')}...`}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddUpdateStrategyModal;
